import { ProgramAvailablity } from "src/enums";
import { Channel, ChannelProgram, PlayerUrl, ProgramMessage } from "src/models";
import { TvTypes } from "../types";
import { createAction } from "./create.action";

export namespace TvAction {

    export const showChannelsLoading = () => createAction(TvTypes.SHOW_CHANNELS_LOADING);
    export const hideChannelsLoading = () => createAction(TvTypes.HIDE_CHANNELS_LOADING);

    export const showConductorLoading = () => createAction(TvTypes.SHOW_TV_CONDUCTOR_LOADING);
    export const hideConductorLoading = () => createAction(TvTypes.HIDE_TV_CONDUCTOR_LOADING);

    export const requestChannels = () => createAction(TvTypes.REQUEST_CHANNEL_LIST);
    export const setChannels = (channels: Channel[]) => createAction(TvTypes.SET_CHANNEL_LIST, channels);

    export const setCurrentChannel = (channel?: Channel) => createAction(TvTypes.SET_TV_CONDUCTOR_CURRENR_CHANNEL, channel);
    export const setSearchText = (text?: string) => createAction(TvTypes.SET_TV_CONDUCTOR_SEARCH_TEXT, text);
    export const setCurrentDate = (date?: Date) => createAction(TvTypes.SET_TV_CONDUCTOR_CURRENR_DATE, date);

    export const requestConductor = (channel: Channel, date?: Date, text?: string) =>
        createAction(TvTypes.REQUEST_TV_CONDUCTOR_LIST, { channel, date, text });
    export const setConductor = (conductor: ChannelProgram[]) => createAction(TvTypes.SET_TV_CONDUCTOR_LIST, conductor);

    export const showConductor = () => createAction(TvTypes.SHOW_TV_CONDUCTOR);
    export const hideConductor = () => createAction(TvTypes.HIDE_TV_CONDUCTOR);
    export const toggleConductor = () => createAction(TvTypes.TOGGLE_TV_CONDUCTOR);

    export const getStreamUrl = (channelId: number, conductorId?: number, killSessionId?: string) => createAction(TvTypes.GET_STREAM_URL, { channelId, conductorId, killSessionId });
    export const setStreamUrl = (player?: PlayerUrl) => createAction(TvTypes.SET_STREAM_URL, player);
    export const startReporting = (channelId: number, conductorId?: number) => createAction(TvTypes.START_TV_PLAYBACK_REPORTING, { channelId, conductorId });
    export const stopReporting = () => createAction(TvTypes.STOP_TV_PLAYBACK_REPORTING);
    export const reportPlayback = (payload?: any) => createAction(TvTypes.DO_TV_REPORT_PLAYBACK, payload);
    export const reportStatistic = (payload?: any) => createAction(TvTypes.DO_TV_REPORT_STATISTIC, payload);

    export const setCurrentEpisode = (episode?: ChannelProgram) => createAction(TvTypes.SET_TV_CURRENT_EPISODE, episode);

    export const setTvStatus = (status: ProgramAvailablity) => createAction(TvTypes.SET_TV_STATUS, status);
    export const setTvMessage = (message: ProgramMessage) => createAction(TvTypes.SET_TV_MESSAGE, message);
    export const clearTvMessage = () => createAction(TvTypes.CLEAR_TV_MESSAGE);
    export const setOtherSessions = (sessions: string[]) => createAction(TvTypes.SET_TV_OTHER_SESSIONS, sessions);

}